<p>
  redirect-device-local-ip works!
</p>



// WEBPACK FOOTER //
// ./src/app/element/redirect-device-local-ip/redirect-device-local-ip.component.html